import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PatientQueueItem from './Reception/PatientQueueItem';
import PatientDetails from './patientDetails';
import { 
   fetchPatients,
   selectPatients,
   selectSelectedPatient,
   setSelectedPatient, 
  } from '../../../ReduxSlices/Patients/patientSlice';

import {
  fetchQueue,
  updateQueueStatus,
  callInPatient,
  updateQueue,
  selectQueue,
  selectQueueLoading,
  selectQueueError,
}  from '../../../ReduxSlices/Patients/patientQueueSlice';
import LoadingDots from '../../shared/LoadingDots';

const QueueList = ({role}) => {
  const dispatch = useDispatch();
  
  const patients = useSelector(selectPatients);
  const queue =  useSelector(selectQueue);
  const loading = useSelector(selectQueueLoading);
  const error = useSelector(selectQueueError);
  const selectedPatient = useSelector(selectSelectedPatient);
  
  useEffect(() => {
    if (patients.length === 0) {
      dispatch(fetchPatients());
    }
    
    if (queue.length === 0) {
      dispatch(fetchQueue());
    }
  }, [dispatch, patients.length, queue.length]);
  
  const handleStatusChange = async (id, status) => {
    const prevEntry = queue.find((e) => e.id === id);
    dispatch(updateQueue({ actionType: 'update', entry: { id, status } }));
    
    try {
      await dispatch(updateQueueStatus({ id, status })).unwrap();
    } catch (err) {
      console.error("Status update failed:", err);
      // rollback
      dispatch(updateQueue({ actionType: 'update', entry: { id, status: prevEntry.status } }));
    }
  };
  
  
  if (selectedPatient) {
    return (
      <PatientDetails
      patient={selectedPatient} role={role}
      />
    );
  }
  
  const filteredQueue = queue.filter(
    (entry) => !(role === 'doctor' && entry.intent === 'lab')
  );
  
  
  return (
    <div className="queue p-4 bg-white rounded shadow mt-8">
      <h2 className="text-xl font-bold mb-4"> Patient Queue</h2>

      {/* Patient Queue Display */}
      {loading && <LoadingDots height={10} width={30} color="#38AD3E" />
}

      {!loading && filteredQueue.length === 0 && (
        <p>No patients in the queue.</p>
      )}

      {!loading && filteredQueue.length > 0 && (
        <ul className="queue-items divide-y">
        {filteredQueue.map((entry, index) => {
         // console.log('QUEUE ENTRY:', entry);

          return (
            <PatientQueueItem
              key={entry.id}
              entry={entry}
              position={index + 1}
              onStartVisit={(id) => handleStatusChange(id, 'being_seen')}
              onMarkDone={(id) => handleStatusChange(id, 'done')}
              onClick={() => dispatch(setSelectedPatient({  ...entry.patient, patientQueueId: entry.id }))}
              onMarkWaitingLab={(id) => handleStatusChange(id, 'waiting_for_lab_results')}
              onCallIn={(id) => dispatch(callInPatient(id))}
              canCallIn
              canStartVisit
              role={role}
            />
          );
        })}
      </ul>
      )}
    </div>
  );
};

export default QueueList;
